import { Modal } from 'antd';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import DF from 'DisplayFramework';
import React, { useState } from 'react';
type APIsInfoProps = {
  visible: boolean;
  onCancel: () => void;
};
const APIsInfo = (props: APIsInfoProps) => {
  const { visible, onCancel } = props;

  const [data] = useState<Array<any>>([]);

  const columns: DataGridColDef<any>[] = [
    {
      dataIndex: 'Component',
      comcode: 'Component',
      width: '30%',
    },
    {
      dataIndex: 'info',
      comcode: 'Version – Name – Time',
      width: '70%',
    },
  ];

  return (
    <DF.Provider pagcode="apiversions">
      <Modal visible={visible} onCancel={onCancel} footer={null} width={800} title={null}>
        <DataGrid
          columns={columns}
          dataSource={data}
          pagination={{
            simple: true,
            pageSize: 22,
            hideOnSinglePage: true,
            responsive: true,
          }}
          size="small"
          scroll={undefined}
        />
      </Modal>
    </DF.Provider>
  );
};

export default APIsInfo;
